import { useEffect } from "react";
import { useProject } from "../../context/ProjectContext";

interface ProjectSelectorProps {
  onlyRead?: boolean
}

const ProjectSelector: React.FC<ProjectSelectorProps> = ({
  onlyRead,
}) => {
  const { setSelectedProject, selectedProject, projectsList, isProjectUndefined } = useProject();

  useEffect(() => {
    if (isProjectUndefined()) {
      setSelectedProject(projectsList[0].id)
    }
  }, [])

  return (
    <div className={`project-selector-section ${onlyRead ? 'disabled' : ''}`}>
      {
        projectsList.map((item, index) => (
          <button className={`${selectedProject === item.id ? 'project-selector-active' : 'project-selector-inactive'}`} disabled={onlyRead}
            key={index}
            onClick={() => setSelectedProject(item.id)}>
            {item.label}
          </button>

        ))
      }

    </div>
  )
}

export default ProjectSelector